import(/* webpackMode: "eager" */ "/workspace/dotheforgejo/oxpa-pro/src/app/(auth)/register/page.tsx");
